module.exports = __webpack_public_path__ + "static/map-germany-fa0c4318f05c1b1a7920c54faf196ed5.png";